<template>
  <vx-card>
    <h3 class="gw-det-title">Concepto general</h3>

    <!-- El veredicto es el titular del bloque, pero no hace falta que grite:
         antes salia a 36px y centrado, y repetido tambien en el encabezado. -->
    <div class="gw-cg-veredicto" :style="{ color: colorVeredicto }">
      {{ project.overall_final_name }}
    </div>
    <p class="gw-cg-detalle" v-if="project.overall_final_detail">
      {{ project.overall_final_detail }}
    </p>

    <div v-if="areas.length" class="gw-cg-areas">
      <div
        v-for="(area, i) in areas"
        :key="i"
        class="gw-cg-area"
        :title="area.observation || ''"
      >
        <div class="gw-cg-area-nombre">
          {{ area.name }}
          <span v-if="area.observation" class="gw-cg-area-nota">ⓘ</span>
        </div>
        <div class="gw-cg-area-nota-valor">
          <star-rating
            read-only
            :show-rating="false"
            inactive-color="#e4e4e4"
            :active-color="colorEstrella(area.value)"
            :rating="area.value"
            :max-rating="5"
            :star-size="15"
            :padding="2"
          />
          <span class="gw-cg-area-numero">{{ area.value }}</span>
        </div>
      </div>
    </div>

    <p class="gw-cg-leyenda" v-if="areas.length">
      5 es toda la información verificada con resultado positivo; 1, resultados
      generales adversos. Pasa el cursor por un área para ver la observación.
    </p>
  </vx-card>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  name: "ProjectConceptGeneral",
  props: {
    project: Object,
  },

  computed: {
    areas() {
      var lista = (this.project || {}).general_concepts;
      if (!Array.isArray(lista)) return [];
      return lista.filter(function (d) {
        return d.value > 0 && d.name !== "Concepto General";
      });
    },

    colorVeredicto() {
      return this.colorVeredictoDe((this.project || {}).overall_final);
    },
  },

  methods: {
    colorEstrella(value) {
      if (value >= 4) return "rgb(80, 181, 75)";
      if (value === 3) return "rgb(255, 159, 67)";
      return "rgb(201, 74, 23)";
    },

    colorVeredictoDe(value) {
      if (value === 0) return "rgb(201, 74, 23)";
      if (value === 1) return "rgb(80, 181, 75)";
      if (value === 2) return "#FF9F43";
      return "rgb(153, 153, 153)";
    },
  },

  components: {
    StarRating,
  },
};
</script>

<style scoped>
.gw-cg-veredicto {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.01em;
  margin: 6px 0 4px;
}
.gw-cg-detalle {
  font-size: 13.5px;
  color: #6b6b6b;
  margin: 0 0 20px;
  max-width: 76ch;
}
.gw-cg-areas {
  display: grid;
  /* Con 1fr las celdas se estiraban a todo el ancho y el nombre quedaba muy
     lejos de sus estrellas. Se acotan para que el par se lea junto. */
  grid-template-columns: repeat(auto-fit, minmax(280px, 380px));
  justify-content: start;
  gap: 0 40px;
}
.gw-cg-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 9px 0;
  border-bottom: 1px solid #f4f4f4;
}
.gw-cg-area-nombre {
  font-size: 13px;
  color: #3b3b3b;
}
.gw-cg-area-nota {
  color: #b9a0c9;
  font-size: 11px;
  cursor: help;
}
.gw-cg-area-nota-valor {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.gw-cg-area-numero {
  font-size: 12px;
  color: #9a9a9a;
  font-variant-numeric: tabular-nums;
}
.gw-cg-leyenda {
  font-size: 11.5px;
  color: #9a9a9a;
  margin: 16px 0 0;
  max-width: 76ch;
}
</style>
